const stats = [
  { icon: 'ri-shield-check-line', value: '5,000+', label: '收录正品网站' },
  { icon: 'ri-user-heart-line', value: '500万+', label: '累计服务用户' },
  { icon: 'ri-shield-star-line', value: '99.9%', label: '网站安全率' },
  { icon: 'ri-award-line', value: '10+', label: '权威分类' },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            值得信赖的导航平台
          </h2>
          <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto">
            数据说明一切，正品蓝导航用实力赢得用户信任
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                <i className={`${stat.icon} text-2xl text-background-50/90`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/75">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}